import React, { Component } from "react";
import { connect } from "react-redux";
import UISnackbar from "./UISnackbar";
import { SnackbarState } from "../../types/snackbar";

type Props = {
  snackbar: SnackbarState,
};

const mapStateToProps = (state) => ({
  snackbar: state.snackbar,
});

class SnackbarWrapper extends Component<Props> {
  render() {
    const { snackbar } = this.props;
    return (
      <UISnackbar type="inline" isOpen={snackbar.isActive}>
        <p>{snackbar.message}</p>
      </UISnackbar>
    );
  }
}

export default connect(mapStateToProps)(SnackbarWrapper);
